<template>
    <div class="cost-estimate" v-if="showCostEstimateLink">
      <hp5-semantic size-selection="sm">
        <hp5-call-to-action
          :data-card-rank="rank"
          :href="estimateUrl"
          screen-reader-only-text="Get a cost estimate"
          size="sm"
          target="_self"
          text="Get a cost estimate"
          type="secondary"
        />
      </hp5-semantic>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const estimateUrl = computed(() =>
          `/my/cost-estimates?providerType=practitioner&provider=${props.result.practitionerId}&serviceKeyword=${context.value.term}&fcAssociationId=${props.result.locationId}&lat=${props.result.location.latitude}&long=${props.result.location.longitude}`
        )

    const { profile, context } = useFCPModel()
    const { getPlan, getMedicalPlans } = usePlan(profile, context)
    const plan = computed(() => getPlan())
    const medicalPlans = computed(() => getMedicalPlans())
    const primaryMedPlan = computed(() => medicalPlans.value[0])

       // for PCC users, check if they are currently searching out of their care network
    const outOfNetwork = computed(() => {
      if (!plan.value.primaryCareClinic) {
        return false
      } else if (context.value.careNetworkId === plan.value.primaryCareClinic.careNetwork.id) {
        return false
      } else {
        return true
      }
    })

    // show link if profile should show cost estimates & the context type is doctor & they are
    // searching within their primary medical plan
    // && if they are a PCC user, they are not out of their care network
    // do not show for secondary medical, dental, or non-commercial plans
    const showCostEstimateLink = computed(() =>
        profile.value.isAuthenticated &&
        profile.value.shouldShowCostEstimates &&
        context.value.type === 'doctor' &&
        plan.value === primaryMedPlan.value &&
        !outOfNetwork.value
    )

  </script>
  
  <style lang="scss" scoped>
  .cost-estimate {
    margin-right: var(--spacing-sm);
  }
  </style>